import React, { useState } from 'react';
import { Box, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckIcon from '@mui/icons-material/Check';
import { useSnackbar } from 'notistack';
import StateBadge from 'app/widgets/Shared/StateBadge/StateBadge';
import ConfirmDialog from 'app/shared/widgets/ConfirmDialog';
import orderServices from 'app/services/order-services';

// Los mismos que acepta Distribuidor::CierreManual en el backend. Eliminar no esta: sigue
// siendo la X de la tarjeta.
const MANUAL_ORDER_STATES = [
    { value: 'pending', label: 'Pendiente' },
    { value: 'invoiced', label: 'Documentado' },
    { value: 'picked', label: 'Pickeado' },
    { value: 'prepared', label: 'Preparado' },
    { value: 'in_progress', label: 'En progreso' },
    { value: 'finished', label: 'Finalizado' },
];

/**
 * Rotulo del estado del pedido que, en el plan Distribuidor, abre un menu para cambiarlo a
 * mano. Finalizar pide confirmacion porque tambien finaliza su parada en el viaje (y puede
 * cerrar el viaje si era la ultima).
 *   onChanged(order) recibe el pedido serializado que devuelve el backend.
 */
const ManualOrderStateBadge = ({ order, onChanged = () => {} }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [confirmFinish, setConfirmFinish] = useState(false);
    const [saving, setSaving] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const changeState = (state) => {
        setSaving(true);
        orderServices.updateManualState(order.id, state)
            .then((updated) => {
                onChanged(updated);
                enqueueSnackbar(`Pedido ${order.code} quedó ${updated?.state_name || ''}`.trim(), { variant: 'success' });
            })
            .catch((err) => {
                enqueueSnackbar(err?.response?.data?.error || err?.error || 'No fue posible cambiar el estado', { variant: 'error' });
            })
            .finally(() => {
                setSaving(false);
                setConfirmFinish(false);
            });
    };

    const pick = (state) => {
        setAnchorEl(null);
        if (state === order.state) return;
        if (state === 'finished') {
            setConfirmFinish(true);
            return;
        }
        changeState(state);
    };

    return (
        <>
            <Tooltip arrow placement="left" title="Cambiar estado del pedido">
                <Box
                    component="button"
                    type="button"
                    disabled={saving}
                    onClick={(e) => { e.stopPropagation(); setAnchorEl(e.currentTarget); }}
                    sx={{
                        display: 'inline-flex', alignItems: 'center', p: 0, border: 0,
                        background: 'none', cursor: saving ? 'wait' : 'pointer', opacity: saving ? 0.6 : 1,
                    }}
                >
                    <StateBadge state={order.state} stateName={order.state_name} withIcon={true} />
                    <ArrowDropDownIcon fontSize="small" color="action" />
                </Box>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                onClick={(e) => e.stopPropagation()}
            >
                {MANUAL_ORDER_STATES.map(({ value, label }) => (
                    <MenuItem key={value} dense selected={value === order.state} onClick={() => pick(value)}>
                        <ListItemIcon>{value === order.state && <CheckIcon fontSize="small" />}</ListItemIcon>
                        <ListItemText>{label}</ListItemText>
                    </MenuItem>
                ))}
            </Menu>
            <ConfirmDialog
                open={confirmFinish}
                title="Finalizar pedido"
                message={<>
                    El pedido <strong>{order.code}</strong> quedará Finalizado.
                    <br />Si está en un viaje, su parada queda entregada; si era la última, el viaje se cierra.
                </>}
                confirmText="Finalizar"
                loading={saving}
                onConfirm={() => changeState('finished')}
                onClose={() => setConfirmFinish(false)}
            />
        </>
    );
};

export default ManualOrderStateBadge;
